<template>
  <div>
    <el-button v-if="$hasPerm('tenant:activity_lottery:extraction_threshold')" class="newAdd" @click="openDialog"
      size="mini">修改阈值</el-button>
    <el-dialog title="阈值配置" :visible.sync="moveDialogVisible" width="40%" center @close="clear"
      :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="最小提取数量" :label-width="formLabelWidth" prop="inviteBy">
          <el-input v-model="form.userOpThreshold" class="searchIpt" autocomplete="off" placeholder="输入最小提取数量">
            <template slot="append">USDT</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="clear">关闭</el-button>
        <el-button v-if="$hasPerm('tenant:activity_lottery:extraction_threshold')" size="mini" type="primary"
          @click="add">确认</el-button>

        <!-- <el-button size="mini" @click="clearFiled">重置</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { FINDLANGARR } from '../../constants'
export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        userOpThreshold: '',
        tenantId: 1,
        userOpThresholdCoin: 'USDT',
      },

      formLabelWidth: '110px',
      rules: {
        userOpThreshold: [
          { required: true, message: '请输入最小提取数量', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    ...mapActions('activityLottery', ['addLotteryConfig']),
    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addLotteryConfig(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;

  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }

  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .ipt {
      width: 90%;
    }
  }
}

.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}

.task {
  border: 1px solid #000;
  padding: 12px;
}

.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}

.addTask {}
</style>
